module.exports = __webpack_public_path__ + "media/parallax/separated-leaves-06-91350608.svg";